// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"630":"56b78dcdaeeb9d9c2967","3169":"0b88a5a2340f70961599","3520":"a3c2b474e2dcaf9879fc"}[chunkId] + ".js";
};